import { FC, useState, useEffect, ReactNode, CSSProperties } from 'react';
import { ProTabs, ProBadge } from '../antd';
import classnames from 'classnames';
import { useLayoutContext } from '../PageLayout/context/LayoutContext';
import { LayOutPageHeaderProps, LayOutPageItemEnum } from './interface';
import { TabsProps } from 'antd/lib/tabs';
import { ALL_STATUS } from '../constants/constant';

const tabStyle: CSSProperties = {
  height: '46px',
  boxSizing: 'border-box'
};
const LayOutPageHeader: FC<LayOutPageHeaderProps> = props => {
  const {
    children,
    enumCode,
    type,
    showAll,
    tabsProps,
    tabPaneData,
    badge,
    className,
    actionRef,
    filterTabKeys,
    ...restProps
  } = props;
  const [badgeData, setBadgeData] = useState<any>();
  useEffect(() => {
    initLoad();
  }, []);
  const initLoad = () => {
    if (badge) {
      const { show, fetchApi, formatData, params } = badge;
      if (show && fetchApi) {
        fetchApi(params).then(res => {
          const data = formatData ? formatData(res.data) : res.data;
          setBadgeData(data);
        });
      }
    }
  };
  const renderTabNode = () => {
    let paneData: TabsProps['items'] = [];
    if (enumCode && !tabPaneData) {
      const { enumData } = useLayoutContext();
      const currentCodeEnum = enumData?.[enumCode]?.items;
      if (Array.isArray(currentCodeEnum)) {
        paneData = currentCodeEnum.map(v => ({
          label: v.label,
          key: v.value as string,
        }));
      }
    }
    if (Array.isArray(tabPaneData)) {
      paneData = [...tabPaneData];
    }
    if (showAll) {
      paneData.push({ label: '全部', key: ALL_STATUS });
    }
    if (filterTabKeys) {
      paneData = paneData.filter(item => item.key && !filterTabKeys.includes(item.key));
    }
    paneData = paneData.map(item => {
      let tabNode: ReactNode = item.label;
      if (badgeData && item.key && badgeData[item.key]) {
        tabNode = (
          <ProBadge count={badgeData[item.key]} offset={[10, 0]}>
            {item.label}
          </ProBadge>
        );
      }
      return {
        ...item,
        label: tabNode,
      };
    });
    return (
      <ProTabs
        {...tabsProps}
        items={paneData}
        style={tabStyle}
      />
    );
  };
  const classes = classnames('yb-layout-page-header', className);
  if (actionRef) {
    actionRef.current = {
      onRefresh: initLoad,
    };
  }

  return (
    <div className={classes} {...restProps}>
      {type === 'Tab' ? renderTabNode() : children}
    </div>
  );
};

LayOutPageHeader.displayName = LayOutPageItemEnum.Header;

export default LayOutPageHeader;
